import React from "react";
import { Link } from "react-router-dom";
import {
  FaClipboardList,
  FaCalendarCheck,
  FaComments,
  FaTools,
} from "react-icons/fa";

const EmployeeDashboard: React.FC = () => {
  const cards = [
    {
      title: "My Tasks",
      description: "View and manage your assigned tasks.",
      icon: <FaClipboardList size={40} className="text-[#009fe3]" />,
      link: "/employee/tasks",
    },
    {
      title: "Appointments",
      description: "Manage and confirm appointments.",
      icon: <FaCalendarCheck size={40} className="text-[#009fe3]" />,
      link: "/employee/appointments",
    },
    {
      title: "Customer Support",
      description: "Respond to customer queries and tickets.",
      icon: <FaComments size={40} className="text-[#009fe3]" />,
      link: "/employee/support",
    },
    {
      title: "Employee Tools",
      description: "Access internal tools and resources.",
      icon: <FaTools size={40} className="text-[#009fe3]" />,
      link: "/employee/tools",
    },
  ];

  return (
    <div className="max-w-7xl mx-auto px-6 py-10">
      <div className="text-center mb-10">
        <h1 className="text-4xl font-bold text-[#009fe3] animate-bounce">
          Employee Dashboard
        </h1>
        <p className="mt-2 text-gray-600 text-lg">
          Daily tools and assignments
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {cards.map((card, index) => (
          <Link
            to={card.link}
            key={index}
            className="bg-white hover:shadow-2xl transition-all transform hover:scale-105 shadow-md p-6 rounded-lg flex flex-col justify-between"
          >
            <div className="flex flex-col items-center mb-4">{card.icon}</div>
            <div className="text-center">
              <h3 className="text-xl font-bold text-[#009fe3] mb-2">
                {card.title}
              </h3>
              <p className="text-gray-600 text-sm">{card.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default EmployeeDashboard;
